<template>
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ $t('src/base/basespinner.9012') }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseSpinner'
}
</script>
